export enum SalutationOptionsLabel {
    FEMALE = 'Frau',
    MALE = 'Herr',
    OTHER = 'Keine Angabe',
}

export enum SalutationOptionsValue {
    FEMALE = 'f',
    MALE = 'm',
    OTHER = 'o',
    EMPTY = '',
}

export enum SalutationKeys {
    FEMALE = 'female',
    MALE = 'male',
    OTHER = 'other',
}

export enum ContactLocalStorage {
    KEY = 'contactValuesLocalStorage',
}

export enum NumberOfFields {
    DEFAULT = 9,
    WAZ = 12,
}
